export default __webpack_public_path__ + "static/media/switchToScreenSharing.af807573.svg";